export enum ChatHubRequestTypes {
    SendStartTypingIndicatorAsCustomer = "SendStartTypingIndicatorAsCustomer",
    SendStopTypingIndicatorAsCustomer = "SendStopTypingIndicatorAsCustomer",
    SendStartTypingIndicatorAsOperator = "SendStartTypingIndicatorAsOperator",
    SendStopTypingIndicatorAsOperator = "SendStopTypingIndicatorAsOperator",
}
